import omit from 'lodash/omit';
import { BankOperation } from 'types/embedded/bankOperation';
import { formatInputToTimestamp } from 'utils/date';

import { mergeRelatedFields } from './mergeRelatedFields';

export function transformRelatedData(data: BankOperation): {
  data: [BankOperation, BankOperation];
} {
  const formattedData = mergeRelatedFields(data) as BankOperation;
  const dateOfOperation = formatInputToTimestamp(data.dateOfOperation, { unit: 'seconds' });

  const childData = {
    ...formattedData.related,
    description: '',
    dateOfOperation,
    type: formattedData.type,
  } as BankOperation;

  const parentData = omit(
    {
      ...formattedData,
      dateOfOperation: dateOfOperation!,
    },
    'related',
  );

  return { data: [parentData, childData] };
}
